import Query from "./query";
import { call } from "./use";

export const useQuery = (controller, { sessionId }) => {
  const controllerDisconnect = controller.disconnect.bind(controller);

  const onQueryStart = (event) => {
    call(controller, "onQuery", event);
    call(controller, "onQueryStart", event);
  };

  const onQueryProgress = (event) => {
    call(controller, "onQueryProgress", event);
  };

  const onQueryReady = (event) => {
    call(controller, "onQuery", event);
    call(controller, "onQueryReady", event);
  };

  const onQueryError = (event) => {
    call(controller, "onQuery", event);
    call(controller, "onQueryError", event);
  };

  const onQueryEmpty = (event) => {
    call(controller, "onQueryEmpty", event);
  };

  const listen = () => {
    Query.on("start", sessionId, onQueryStart);
    Query.on("progress", sessionId, onQueryProgress);
    Query.on("ready", sessionId, onQueryReady);
    Query.on("error", sessionId, onQueryError);
    Query.on("empty", sessionId, onQueryEmpty);
  };

  const unlisten = () => {
    Query.off("ready", sessionId, onQueryReady);
    Query.off("progress", sessionId, onQueryProgress);
    Query.off("error", sessionId, onQueryError);
    Query.off("start", sessionId, onQueryStart);
    Query.off("empty", sessionId, onQueryEmpty);
  };

  listen();

  Query.triggerCurrent(sessionId, {
    start: onQueryStart,
    progress: onQueryProgress,
    ready: onQueryReady,
    error: onQueryError,
    empty: onQueryEmpty,
  });

  const disconnect = () => {
    unlisten();
    controllerDisconnect();
  };

  Object.assign(controller, { disconnect });
};
